import { render, staticRenderFns } from "./dsIndex.vue?vue&type=template&id=26d7db60&"
import script from "./dsIndex.vue?vue&type=script&lang=js&"
export * from "./dsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports